import { axiosGet } from "../../Helpers";

export const loadLookupsList = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("lookup/listLookup");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
export const loadLookupsTypes = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("lookup/distinctLookup");
  setLoading(false);
  const data = response.data?.data;

  return data;
};
export const loadLookupsByTypes = async (setLoading, type) => {
  setLoading(true);
  const response = await axiosGet(`lookup/getLookupByType/${type}`);
  setLoading(false);
  const data = response.data?.data;

  return data;
};
